import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import ngx-translate and the http loader
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxCaptchaModule } from 'ngx-captcha';

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';

import { LayoutsModule } from './layouts/layouts.module';
import { PagesModule } from './pages/pages.module';
import { ErrorsModule } from './errors/errors.module';
import { UserData } from './models';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export function TranslationLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
/*
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../translations/password-recovery/', '.json');
}
*/

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationLoaderFactory,
        // useFactory: HttpLoaderFactory,
        deps: [HttpClient]}
    }),
    AppRoutes,
    LayoutsModule,
    PagesModule,
    ErrorsModule,
    NgxCaptchaModule,
    BrowserAnimationsModule
  ],
  providers: [
    UserData
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
